<template>
  <div>
    <div class="loginhead">
      <div class="headleft">
        <div class="logoAndname">
          <img
            src="~@/assets/images/login/pic-logo.png"
            style="width: 100%; height: 100%;object-fit:cover;"
          />
        </div>
        <div class="headnav">
          <a
            href="#nogo"
            @click="tip(item)"
            v-for="(item, index) in navArr"
            :key="index"
            >{{ item.name }}</a
          >
        </div>
        <div class="headlefticon" v-if="user.id > 0">
          <div
            style="
              color: #fff;
              display: flex;
              flex-direction: row;
              align-items: center;
              margin-left: 10px;
              font-size: 16px;
            "
            v-rblink="{path:'/updateinfo'}"
            class="headlefticon_name"
          >
            {{ user.name }}
          </div>
          <div class="headicon">
            <div class="loginbtn registerbtn" @click="logout">退出</div>
          </div>
        </div>
        <div class="headlefticon" v-else>
          <div class="headicon">
            <div class="loginbtn">登录</div>
          </div>
          <div class="headicon">
            <div class="loginbtn registerbtn">注册</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style  lang="scss" scoped>
.loginhead {
  height: 100px;
  background: #1981ff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .headleft {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 1240px;
    .logoAndname {
      display: flex;
      align-items: center;
      width: 160px;
      // height: 40px;
      background-size: cover;
      -webkit-background-size: cover;
    }
    .headnav {
      flex: 1;
      height: 100px;
      line-height: 100px;
      text-align: center;
      a {
        font-size: 18px;
        font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
        font-weight: 400;
        color: #ffffff;
        margin-right: 24px;
        &:hover {
          cursor: pointer;
          font-weight: bold;
        }
      }
    }
    .headlefticon {
      display: flex;
      flex-direction: row;
      /*width: 138px;*/
      height: 36px;
      margin-left: 0px;
      .headlefticon_name{
        &:hover{
          cursor: pointer;
        }
      }
      .headicon {
        &:first-child {
          margin-left: 0px;
        }
        display: flex;
        flex-direction: row;
        margin-left: 10px;
        align-items: center;
        .loginbtn {
          background: #4e81df;
          text-align: center;
          height: 36px;
          width: 64px;
          line-height: 32px;
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.3);
          border-radius: 19px;
          border: 2px solid #ffffff;
          font-size: 16px;
          
          font-weight: 400;
          color: #ffffff;
          box-sizing: border-box;
          &:hover {
            cursor: pointer;
            opacity: 0.8;
            font-weight: bold;
          }
        }
        .registerbtn {
          background: #d22c46;
        }
      }
    }
  }
}
</style>
<script>
import { Dialog } from "vant";
export default {
  name: "HeadNav",
  components: {
    Dialog,
  },
  props: {},
  // ..
  data: function () {
    return {
      navArr: [
        { name: "首页", class: "nav_active", id: "113" },
        { name: "关于我们", class: "", id: "96" },
        { name: "新闻资讯", class: "", id: "97" },
        { name: "通知公告", class: "", id: "115" },
        { name: "开放课程", class: "", id: "course-20" },
        { name: "各类下载", class: "", id: "100" },
        { name: "相关查询", class: "", id: "146" },
      ],
      user: {
        id: 0,
        name: "",
      },
    };
  },

  created() {
    var _token = localStorage.getItem("_token");
    console.log(_token);
    if(_token){
      this.getUser();
    }
  },
  methods: {
    getUser() {
      let that = this;
      that.$api.post(
        "/api/index/userdata",
        {},
        (r) => {
          that.user = r.data;
        },
        (r) => {
          // that.$message.error(r.msg);
        }
      );
    },

    logout() {
      let that = this;
      this.$confirm("确定退出吗？")
        .then((_) => {
          that.$api.post("/api/index/logout", {}, (r) => {
            localStorage.removeItem("_token");
            that.$router.push({ name: "Login" });
          });
        })
        .catch((_) => {});
    },
    tip(item) {
        this.$router.push({path:"cate",query:{id:item.id}})
    //   this.$message.warning("正在建设中");
    },
  },

  filters: {},
  watch: {
    $route: {
      handler() {
        var _token = localStorage.getItem("_token");
        if (_token&&!this.user.id) {
          this.getUser();
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// HeadNav.vue?7e2021f0